<script lang="ts">
  import { page } from '$app/stores';
  import { FreemiumBanner, MetaTags, MobileControls, RenderPage } from '$lib';
  import { LandingPageConfiguration } from 'customer-components/lib/components';
  import { MarketingPageConfiguration } from 'customer-components/lib/marketing';
  import { onMount, setContext } from 'svelte';
  import { dev } from '$app/environment';

  export let data;

  let {
    generalSettings,
    landingPageModel,
    pageType,
    editorView,
    previewMode,
    businessIdentifier,
    pageIdentifier,
  } = data;

  $: ({
    generalSettings,
    landingPageModel,
    pageType,
    editorView,
    previewMode,
    businessIdentifier,
    pageIdentifier,
  } = data);

  let pageSettings = editorView
    ? null
    : {
        generalSettings: generalSettings,
        ...landingPageModel.index,
      };

  $: subscriptionsStatus = landingPageModel?.websiteSubscriptionStatus;

  let isMounted = editorView || previewMode ? false : true;

  //set all context variables for all the customer components
  setContext('isEditable', editorView);

  if (!editorView) {
    setContext<string>('lpKey', businessIdentifier);
    setContext<string>('hash', landingPageModel.index.userHash);
    setContext<string>('service', pageIdentifier);
    setContext<string>('gclid', $page.url.searchParams.get('gclid'));
    setContext<string>('country', landingPageModel.country);
  }

  onMount(() => {
    //Required for Tracking
    if (!editorView)
      document.cookie = 'voolt-hash=' + landingPageModel.index.userHash;

    //Script to load only on the editor view
    if (editorView || previewMode) {
      window.parent.postMessage({ type: 'load' }, '*');
      window.addEventListener('message', event => {
        if (event.data && event.data.type === 'updateLandingPageModel') {
          if (
            event.origin.includes('voolt.com') ||
            event.origin.includes('localhost')
          ) {
            landingPageModel = event.data.landingPageModel;
            pageSettings = {
              generalSettings: event.data.generalSettings,
              ...event.data.landingPageModel.index,
            };
            pageType = event.data.pageType;
            isMounted = true;
          }
        }
      });
    }
  });
</script>

<svelte:head>
  {#if subscriptionsStatus != 'active' || editorView || pageType === 'marketing' || dev}
    <!-- Prevent index  -->
    <meta name="robots" content="noindex, nofollow" />
  {/if}

  {#if !editorView}
    <!-- Google Tag Manager -->
    <script>
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-WPVZGRX3');
    </script>
    <!-- End Google Tag Manager -->

    {#if pageType === 'marketing'}
      {@html pageSettings.mktSettings?.headerCode.richText}

      {#if pageSettings.mktSettings?.gadsSubMccTagId}
        <!-- Google tag SubMCC (gtag.js) -->

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id={pageSettings
            .mktSettings?.gadsSubMccTagId}"
        ></script>
        {@html `<script>
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag('js', new Date());

          gtag('config', '${pageSettings.mktSettings?.gadsSubMccTagId}');
        </script>
        <script>
          console.log('Loaded SubMCC Gtag ${pageSettings.mktSettings?.gadsSubMccTagId}')
        </script>
          `}
      {/if}
    {/if}

    {#if !previewMode && pageType !== 'marketing' && generalSettings?.tracking?.gaMeasurementID}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id={generalSettings
          .tracking.gaMeasurementID}"
      ></script>
      {@html `
        <script>
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${generalSettings.tracking.gaMeasurementID}');
        </script>
      `}
    {/if}
  {/if}
</svelte:head>
{#if isMounted}
  {#if !editorView && !previewMode}
    <MetaTags {landingPageModel} />
  {/if}

  {#if !editorView && !previewMode && ['suspended', 'cancelled'].includes(subscriptionsStatus) && pageType === 'default'}
    <FreemiumBanner />
  {/if}
  {#if pageSettings}
    {#key pageSettings}
      {#if pageType === 'marketing'}
        <MarketingPageConfiguration />
      {:else}
        <LandingPageConfiguration
          colors={pageSettings.brand?.palette?.colors}
          fonts={{
            headingFont: pageSettings.headingFont,
            paragraphFont: pageSettings.paragraphFont,
          }}
        />
      {/if}
    {/key}
  {/if}

  <RenderPage
    {editorView}
    {landingPageModel}
    {pageSettings}
    {subscriptionsStatus}
    {pageType}
  />

  {#if data.pageType === 'marketing' && !editorView}
    <!-- Marketing Footer code -->
    <script
      type="text/javascript"
      src={pageSettings.mktSettings?.thirdParty.callRail?.clientId}
    ></script>
    <div class="footer-code">
      {@html pageSettings.mktSettings?.footerCode.richText}
    </div>
  {/if}
{/if}

<style>
  .footer-code {
    width: 0;
    height: 0;
    overflow: hidden;
  }
</style>
